module.exports = __webpack_public_path__ + "static/media/menu25.6d87a8e4.jpg";